import script from "./GuestLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./GuestLayout.vue?vue&type=script&setup=true&lang=js"

import "./GuestLayout.vue?vue&type=style&index=0&id=4f63c7dd&lang=scss"

const __exports__ = script;

export default __exports__